import classNames from 'classnames';
import { useMemo } from 'react';
import { IFirstHandReport } from 'api/home/types';
import { IResortPathInfo } from 'api/resort/types';
import { SwiperComponent, SwiperSlideItem } from 'components/blocks/SwiperComponent';
import { FirstHandReportItem } from './FirstHandReportItem';
import styles from './styles.module.scss';

const swiperBreakpoints = {
  375: {
    slidesPerView: 1.2,
  },
  640: {
    slidesPerView: 1.7,
  },
  1200: {
    slidesPerView: 3,
  },
};

interface Props {
  title: string;
  slides: JSX.Element[];
  reports: IFirstHandReport[];
  regionResorts: Array<IResortPathInfo>;
  controlsHiddenOnMobile?: boolean;
}

export const NewGuideSlider = ({
  title, reports, regionResorts,
}: Props) => {
  const resortPathInfoByUuid = new Map<number, IResortPathInfo>(
    (regionResorts ?? []).map((resort) => [Number(resort.uuid), resort]),
  );

  const filteredReports = reports.filter((item) => item.largeImage !== null);

  const slides: SwiperSlideItem[] = useMemo(() => filteredReports.map((item) => ({
    key: item.uuid,
    content: (
      <FirstHandReportItem
        {...item}
        resortPathInfo={resortPathInfoByUuid.get(item.resortUuid)}
      />
    ),
  })), [filteredReports, resortPathInfoByUuid]);

  return (
    <section className={classNames(styles.wrapper, 'mt-4')}>
      {title && (
        <div className={styles.header}>
          <h2>{title}</h2>
        </div>
      )}
      <SwiperComponent
        slides={slides}
        breakpoints={swiperBreakpoints}
        spaceBetween={16}
        navigationThreshold={3}
        wrapperClassName={styles.wrapperBox}
        sliderWrapperClassName={styles.sliderWrapper}
        swiperClassName={styles.swiper}
        slideClassName={styles.slide}
        navButtonClassName={styles.swiperNavButton}
        prevButtonClassName={styles.swiperButtonPrev}
        nextButtonClassName={styles.swiperButtonNext}
      />
    </section>
  );
};
